import totalTeamCpdProgress from './total-team-cpd-progress';

const cpdTeamActivityReport = ({ businessTeamsWithStats, ...data }) => [
  ...totalTeamCpdProgress({
    ...data,
    businessTeamsWithStats
  })
];

export default cpdTeamActivityReport;



// WEBPACK FOOTER //
// ./src/reports/cpd-team-activity.js